import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AuthenticationService } from '../../../_services/auth/authentication.service';
import { PenggunaModel } from '../../../_model/auth/authentication.model';
import { CurrentFaseModel, FaseModel } from './fase.model';
import { environment } from '../../../../environments/environment';
import { SkpdService } from '../skpd.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class FaseService {
  skpdId!: string;
  currentOtor!: string;
  tahunAnggaran: any = localStorage.getItem('defaultYear')?.replace(/\D/g, '');

  constructor(
    private httpClient: HttpClient,
    private _authService: AuthenticationService,
    private skpdService: SkpdService,
    private router: Router
  ) {
    this.tahunAnggaran = localStorage.getItem('defaultYear')?.replace(/\D/g, '');
    const pengguna: PenggunaModel = _authService.currentUserDetail;
    this.skpdId = String(skpdService.getCurrentSkpd().id);
    this.currentOtor = pengguna.otor;
  }

  getCurrentFase() {
    let params = new HttpParams();
    params = params.append('tahunAnggaran', localStorage.getItem('defaultYear'));
    params = params.append('idSkpd', this.skpdId);
    return this.httpClient.get<CurrentFaseModel>(`${environment.uriApi}/api/fase/current-fase`, { params: params });
  }

  getListFase() {
    return this.httpClient.get<FaseModel>(`${environment.uriApi}/api/fase/listFase`, { observe: 'response' });
  }

  toPelaksanaan() {
    let params = new HttpParams();
    params = params.append('tahunAnggaran', localStorage.getItem('defaultYear')?.replace(/\D/g, ''));
    return this.httpClient.get<CurrentFaseModel>(`${environment.uriApi}/api/fase/to-pelaksanaan`, { params: params, observe: 'response' });
  }

  lockFase(idSkpd: number) {
    let params = new HttpParams();
    params = params.append('tahunAnggaran', localStorage.getItem('defaultYear')?.replace(/\D/g, ''));
    params = params.append('idSkpd', String(idSkpd));
    return this.httpClient.get<CurrentFaseModel>(`${environment.uriApi}/api/fase/lockFaseSkpd`, { params: params, observe: 'response' });
  }

  openPelaksanaan(idSkpd: number) {
    let params = new HttpParams();
    params = params.append('tahunAnggaran', localStorage.getItem('defaultYear')?.replace(/\D/g, ''));
    params = params.append('idSkpd', String(idSkpd));
    return this.httpClient.get<CurrentFaseModel>(`${environment.uriApi}/api/fase/open-pelaksanaan`, { params: params, observe: 'response' });
  }

  toPergeseran() {
    let params = new HttpParams();
    params = params.append('tahunAnggaran', localStorage.getItem('defaultYear')?.replace(/\D/g, ''));
    return this.httpClient.get<CurrentFaseModel>(`${environment.uriApi}/api/fase/to-pergeseran`, { params: params, observe: 'response' });
  }

  openPergeseran(idSkpd: number) {
    let params = new HttpParams();
    params = params.append('tahunAnggaran', localStorage.getItem('defaultYear')?.replace(/\D/g, ''));
    params = params.append('idSkpd', String(idSkpd));
    return this.httpClient.get<CurrentFaseModel>(`${environment.uriApi}/api/fase/open-pergeseran`, { params: params, observe: 'response' });
  }

  toPerubahan() {
    let params = new HttpParams();
    params = params.append('tahunAnggaran', localStorage.getItem('defaultYear')?.replace(/\D/g, ''));
    return this.httpClient.get<CurrentFaseModel>(`${environment.uriApi}/api/fase/to-perubahan-new`, { params: params, observe: 'response' });
  }

  openPerubahan(idSkpd: number) {
    let params = new HttpParams();
    params = params.append('tahunAnggaran', localStorage.getItem('defaultYear')?.replace(/\D/g, ''));
    params = params.append('idSkpd', String(idSkpd));
    return this.httpClient.get<CurrentFaseModel>(`${environment.uriApi}/api/fase/open-perubahan`, { params: params, observe: 'response' });
  }
}
